import { render, staticRenderFns } from "./policyTsft2.vue?vue&type=template&id=471cfc8f"
import script from "./policyTsft2.vue?vue&type=script&lang=js"
export * from "./policyTsft2.vue?vue&type=script&lang=js"
import style0 from "./policyTsft2.vue?vue&type=style&index=0&id=471cfc8f&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports